// extracted by mini-css-extract-plugin
export default {"label":"GucS5Kts","chainLabel":"lVgseMt9","rwaStockLabel":"Av7aCz70"};